import _typeof from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _defineProperty from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/es.uint8-array.set-from-base64.js";
import "core-js/modules/es.uint8-array.set-from-hex.js";
import "core-js/modules/es.uint8-array.to-base64.js";
import "core-js/modules/es.uint8-array.to-hex.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import config from '@/pathConfig';
import { getDocumentFillDataById, documentProcess, queryDocTodoDet, auditDocTodo, queryTempThreeContent, downloadFile } from '@/api/notice/documentApi.js';
var Base64 = require('js-base64').Base64;
export default {
  data: function data() {
    return {
      needData: {},
      config: config,
      userInfo: this.$hdk.userInfo.get(),
      title: '',
      mode: '',
      form: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
        proposedsignimg: '',
        proposedsigndate: '',
        memorandumsignimg: '',
        memorandumsigndate: '',
        auditStep: undefined,
        tempId: undefined,
        id: undefined,
        auditId: undefined,
        urgency: undefined,
        secretLevel: undefined,
        fileList: [],
        fileNameGroup: [],
        copyDelivery: {
          organData: [],
          postData: [],
          userData: [],
          organId: 0,
          postId: 0
        },
        csNameList: [],
        mainDelivery: {
          organData: [],
          postData: [],
          userData: [],
          organId: 0,
          postId: 0
        },
        zsNameList: [],
        docData: {},
        fileName: undefined,
        fileCode: undefined,
        auditOpinion: undefined,
        auditStatus: 1,
        isCounterSign: 0,
        expireTime: undefined,
        passPercentage: undefined,
        filePath: undefined
      }, "fileName", undefined), "oldFileName", undefined), "formDate", undefined), "shareency", undefined), "isEmergent", undefined),
      previewSrc: '',
      previewShow: false,
      flowList: [],
      rulesAudit: {
        auditStatus: [{
          required: true,
          message: '请选择是否通过',
          trigger: 'change'
        }]
      },
      rulesAuditRecheck: {
        auditStatus: [{
          required: true,
          message: '请选择是否通过',
          trigger: 'change'
        }],
        isCounterSign: [{
          required: true,
          message: '请选择是否需要会签',
          trigger: 'change'
        }],
        expireTime: [{
          required: true,
          message: '请选择会签过期时间',
          trigger: 'change'
        }],
        passPercentage: [{
          required: true,
          message: '请输入会签通过百分比',
          trigger: 'input'
        }]
      },
      columns: [{
        title: '会签人',
        dataIndex: 'userName',
        key: 'userName'
      }, {
        title: '会签状态',
        dataIndex: 'auditStatus',
        key: 'auditStatus',
        align: 'center',
        scopedSlots: {
          customRender: 'auditStatus'
        }
      }, {
        title: '会签时间',
        dataIndex: 'processTime',
        key: 'processTime'
      }]
    };
  },
  watch: {
    'form.mainDelivery': function formMainDelivery(n, o) {
      this.form.zsNameList = [];
      if (n.organData) {
        var organData = n.organData;
        if (organData.length > 0) {
          for (var i = 0; i < organData.length; i++) {
            this.form.zsNameList.push(organData[i].name);
          }
        }
      }
      if (n.postData) {
        var postData = n.postData;
        if (postData.length > 0) {
          for (var i = 0; i < postData.length; i++) {
            this.form.zsNameList.push(postData[i].name);
          }
        }
      }
      if (n.userData) {
        var userData = n.userData;
        if (userData.length > 0) {
          for (var i = 0; i < userData.length; i++) {
            this.form.zsNameList.push(userData[i].name);
          }
        }
      }
    },
    'form.copyDelivery': function formCopyDelivery(n, o) {
      this.form.csNameList = [];
      if (n.organData) {
        var organData = n.organData;
        if (organData.length > 0) {
          for (var i = 0; i < organData.length; i++) {
            this.form.csNameList.push(organData[i].name);
          }
        }
      }
      if (n.postData) {
        var postData = n.postData;
        if (postData.length > 0) {
          for (var i = 0; i < postData.length; i++) {
            this.form.csNameList.push(postData[i].name);
          }
        }
      }
      if (n.userData) {
        var userData = n.userData;
        if (userData.length > 0) {
          for (var i = 0; i < userData.length; i++) {
            this.form.csNameList.push(userData[i].name);
          }
        }
      }
    },
    'form.fileList': function formFileList(n, o) {
      if (n.length > 0) {
        this.form.fileNameGroup = [];
        for (var i = 0; i < n.length; i++) {
          this.form.fileNameGroup.push(n[i].name);
        }
      }
    }
  },
  methods: {
    backPage: function backPage() {
      if (this.$route.query.data.path == 'system') {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: '/docNotice/doc/docDeal'
        });
      }
    },
    handlePreview: function handlePreview(file) {
      var url = file.response.data.url;
      var fileUrl = config.baseUrl + url;
      window.open(config.filePreview + '?url=' + encodeURIComponent(Base64.encode(fileUrl)), '_blank');

      // this.previewShow = true;
      // this.previewSrc =
      //     config.filePreview + '?url=' + encodeURIComponent(Base64.encode(fileUrl));
    },
    handleDownPreview: function handleDownPreview(file) {
      var _this = this;
      var url = file.response.data.url;
      var fileUrl = config.baseUrl + url;
      var formData = new FormData();
      formData.append('filePath', fileUrl);
      downloadFile(formData).then(function (res) {
        _this.getFile(res.data.message, file.name);
      });
    },
    getFile: function getFile(base64, fileName) {
      var bytes = window.atob(base64),
        n = bytes.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bytes.charCodeAt(n);
      }
      var blob = null;
      if (!window.Blob) alert("当前浏览器不支持该Blob,请升级浏览器或使用Chrome浏览器");else blob = new Blob([u8arr]);
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(url.src, url.name);
      } else {
        var link = document.createElement("a");
        link.setAttribute("href", window.URL.createObjectURL(blob));
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    },
    handleCancel: function handleCancel() {
      this.previewShow = false;
    },
    getProcess: function getProcess() {
      var _this2 = this;
      documentProcess(this.form).then(function (res) {
        if (res.data.code == 200) {
          _this2.flowList = res.data.data;
        }
      });
    },
    loadDocDataByAuditId: function loadDocDataByAuditId() {
      var _this3 = this;
      var that = this;
      var req = {
        auditId: this.form.auditId
      };
      queryDocTodoDet(req).then(function (res) {
        if (res.data.code == 200) {
          var docData = {};
          if (_typeof(res.data.data.docData) === 'object' && res.data.data.docData !== null) {
            docData = JSON.parse(res.data.data.docData.value);
          } else {
            docData = JSON.parse(res.data.data.docData);
          }
          // 签名图片处理成数组
          if (docData.meetingImg && docData.meetingImg.length > 0) {
            docData.meetingImg = _.split(docData.meetingImg, ',');
          } else {
            docData.meetingImg = [];
          }
          _this3.form.docData = docData;
          _this3.form.signImgUrl = _this3.form.docData.draftmanpath;
          _this3.form.tempId = res.data.data.tempId;
          _this3.form.createTime = res.data.data.createTime;
          _this3.form.fileName = res.data.data.fileName;
          _this3.form.fileCode = res.data.data.fileCode;
          _this3.form.secretLevel = res.data.data.secretLevel;
          _this3.form.urgency = res.data.data.urgency;
          _this3.form.auditStep = res.data.data.auditstep;
          _this3.form.meetingResult = res.data.data.meetingResult;
          _this3.form.proposedsignimg = docData.proposedsignimg;
          _this3.form.memorandumsignimg = docData.memorandumsignimg;
          if (docData.proposedsigndate) {
            _this3.form.proposedsigndate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(docData.proposedsigndate)[0];
          }
          if (docData.memorandumsigndate) {
            _this3.form.memorandumsigndate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(docData.memorandumsigndate)[0];
          }
          if (_this3.form.tempId === 3 && docData.date) {
            _this3.form.formDate = docData.date;
          }
          if (docData.annexfilelist && docData.annexfilelist.length > 0) {
            for (var i = 0; i < docData.annexfilelist.length; i++) {
              that.form.fileList.push({
                uid: i,
                url: docData.annexfilelist[i].annexpath,
                name: docData.annexfilelist[i].annexname,
                response: {
                  data: {
                    url: docData.annexfilelist[i].annexpath
                  }
                }
              });
            }
          }
          if (!res.data.data.sendScope.mainDelivery) {
            var _mainDelivery = {
              organData: [],
              postData: [],
              userData: []
            };
            res.data.data.sendScope.mainDelivery = _mainDelivery;
          }
          var mainDelivery = res.data.data.sendScope.mainDelivery,
            copyDelivery = res.data.data.sendScope.copyDelivery;
          that.form.mainDelivery.organData = [];
          if (mainDelivery.organData.length > 0) {
            for (var i = 0; i < mainDelivery.organData.length; i++) {
              that.form.mainDelivery.organData.push({
                id: mainDelivery.organData[i].organid,
                name: mainDelivery.organData[i].organname,
                typeId: mainDelivery.organData[i].typeid
              });
            }
          }
          if (mainDelivery.postData.length > 0) {
            for (var i = 0; i < mainDelivery.postData.length; i++) {
              that.form.mainDelivery.postData.push({
                id: mainDelivery.postData[i].postid,
                name: mainDelivery.postData[i].postname,
                type: mainDelivery.postData[i].typeid
              });
            }
          }
          if (mainDelivery.userData.length > 0) {
            for (var i = 0; i < mainDelivery.userData.length; i++) {
              that.form.mainDelivery.userData.push({
                id: mainDelivery.userData[i].userid,
                name: mainDelivery.userData[i].username,
                type: mainDelivery.userData[i].typeid
              });
            }
          }
          if (copyDelivery.organData.length > 0) {
            for (var i = 0; i < copyDelivery.organData.length; i++) {
              that.form.copyDelivery.organData.push({
                id: copyDelivery.organData[i].organid,
                name: copyDelivery.organData[i].organname,
                typeId: copyDelivery.organData[i].typeid
              });
            }
          }
          if (copyDelivery.postData.length > 0) {
            for (var i = 0; i < copyDelivery.postData.length; i++) {
              that.form.copyDelivery.postData.push({
                id: copyDelivery.postData[i].postid,
                name: copyDelivery.postData[i].postname,
                type: copyDelivery.postData[i].typeid
              });
            }
          }
          if (copyDelivery.userData.length > 0) {
            for (var i = 0; i < copyDelivery.userData.length; i++) {
              that.form.copyDelivery.userData.push({
                id: copyDelivery.userData[i].userid,
                name: copyDelivery.userData[i].username,
                type: copyDelivery.userData[i].typeid
              });
            }
          }
          _this3.form.mainDelivery = JSON.parse(JSON.stringify(_this3.form.mainDelivery));
          _this3.form.copyDelivery = JSON.parse(JSON.stringify(_this3.form.copyDelivery));
          if (_this3.form.tempId === 3) {
            queryTempThreeContent(req).then(function (res) {
              if (res.data.code == 200) {
                _this3.form.docData = res.data.data.docData;
              }
            });
          }
        }
      });
    },
    auditDoc: function auditDoc() {
      var _this4 = this;
      var tempId = this.form.tempId;
      var auditStep = this.form.auditStep;
      var auditOpinion = this.form.auditOpinion;
      var auditStatus = this.form.auditStatus;
      var req = {
        id: this.form.auditId,
        tempId: this.form.tempId,
        auditStep: this.form.auditStep,
        fileCode: this.form.fileCode,
        sign: this.userInfo.signImgUrl,
        auditOpinion: this.form.auditOpinion,
        docData: this.form.docData,
        auditStatus: this.form.auditStatus,
        isCounterSign: this.form.isCounterSign,
        expireTime: this.form.expireTime,
        passPercentage: this.form.passPercentage,
        filePath: this.form.filePath,
        fileName: this.form.fileName,
        oldFileName: this.form.oldFileName,
        isEmergent: this.needData.isEmergent
      };
      if (tempId == 2 && auditStep == 6) {
        req.docData.shareency = this.form.shareency;
      }
      this.$refs.form.validate(function (valid) {
        if (valid) {
          auditDocTodo(req).then(function (res) {
            if (res.data.code == 200) {
              _this4.$message.success('成功');
              _this4.backPage();
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  mounted: function mounted() {
    var that = this;
    var query = this.$route.query;
    this.needData = JSON.parse(localStorage.getItem('needData'));
    if (JSON.stringify(this.needData) != '{}') {
      Object.assign(this.form, this.needData);
    }
    this.form.auditId = this.needData.auditId;
    this.mode = query.mode;
    this.getProcess();
    this.loadDocDataByAuditId();
    if (this.mode === 'firstTrial') {
      this.title = '初核';
    } else if (this.mode === 'signIssue') {
      this.title = '签发';
    } else if (this.mode === 'reCheck') {
      this.title = '复核';
    } else if (this.form.tempId === 3) {
      if (this.form.auditStep === 1) {
        this.title = '拟稿部门审核';
      } else if (this.form.auditStep === 2) {
        this.title = '审稿部门审核';
      } else if (this.form.auditStep === 3) {
        this.title = '分管校级领导审核';
      } else if (this.form.auditStep === 4) {
        this.title = '理事长签发';
      }
    } else if (this.mode === 'proofread') {
      this.title = '校对';
    } else if (this.mode === 'print') {
      this.title = '打印';
      this.form.auditStatus = 1;
    } else if (this.mode === 'groupSign') {
      this.title = '会签';
    }
  }
};